import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PageHeader, EmptyState, Badge } from "@/components/Shared";

export default function Orders() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setRows(data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  return (
    <div data-testid="orders-page">
      <PageHeader eyebrow="Adjudication" title="Orders & Awards"
        description="Procedural orders, interim awards and final awards passed by the tribunal in your references." />
      {rows.length === 0 ? (
        <EmptyState testId="orders-empty" title="Nothing passed yet" hint="Orders and awards recorded by the tribunal appear here." />
      ) : (
        <div className="border border-border bg-card overflow-x-auto" data-testid="orders-table">
          <table className="w-full text-sm min-w-[720px]">
            <thead>
              <tr className="border-b border-border bg-muted/60">
                {["No.", "Title", "Case", "Kind", "Issued on"].map((h) => (
                  <th key={h} className="p-4 text-left label-caps font-normal">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((o) => (
                <tr key={o.id} className="border-b border-border last:border-0 hover:bg-accent transition-colors duration-200" data-testid={`order-list-row-${o.id}`}>
                  <td className="p-4 font-mono text-xs">{o.number || "—"}</td>
                  <td className="p-4">
                    <p className="font-medium">{o.title}</p>
                    {o.summary && <p className="text-xs text-muted-foreground mt-1 max-w-xl">{o.summary}</p>}
                  </td>
                  <td className="p-4">
                    <Link to={`/cases/${o.case_id}`} className="font-mono text-xs text-blue-900 dark:text-blue-400 hover:underline">
                      {o.case_number !== "—" ? o.case_number : o.ref_id}
                    </Link>
                  </td>
                  <td className="p-4">
                    <Badge className={o.kind === "final_award" ? "bg-green-50 text-green-900" : "bg-blue-50 text-blue-900"}>
                      {o.kind.replace(/_/g, " ")}
                    </Badge>
                  </td>
                  <td className="p-4 text-muted-foreground whitespace-nowrap">{fmtDate(o.issued_on)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
